const DisabledTenant = (): JSX.Element => {
  return (
    <div className="wrapper">
      <h2>We&apos;ve Moved, but You Still Have Access!</h2>
      <p>
        Your Sage Catalyst collection is now available on a new platform. Whilst
        your notes won&apos;t copy across it means that you now have access to
        an updated collection with even more premium titles and new editions on
        VitalSource Explore. As well as lots of study tools to support your
        learning.
      </p>
      <h3>Here&apos;s what you need to do next</h3>
      <ol>
        <li>
          Go to{" "}
          <a href="https://login.vitalsource.com/?redirect_uri=https%3A%2F%2Fbookshelf.vitalsource.com%2F%23%2Fexplore&brand=bookshelf.vitalsource.com&context=bookshelf">
            VitalSource Bookshelf
          </a>{" "}
          and either sign in if you already have an account or create a new
          account with your institutional email address.
        </li>
        <li>
          Select the <strong>Explore</strong> page to see all the books
          available to you, or use the search function to look for a specific
          title. If you no longer see the title you&apos;re looking for, it may
          have been removed when we updated the collection. You can download the
          full title list{" "}
          <a href="https://learningresources.sagepub.com/docs/learningpillarlibraries/sage-catalyst/catalyst-core-title-list-2025.xlsx?sfvrsn=831c62b_3">
            here
          </a>
          .
        </li>
      </ol>
      <p>
        If you need guidance, visit our{" "}
        <a href="https://learningresources.sagepub.com/catalyst/sage-catalyst-vitalsource-user-guide">
          User Guide
        </a>{" "}
        for step-by-step instructions.
      </p>
      <p>
        For further assistance, please contact your institution&apos;s library
        or our support team at{" "}
        <a href="mailto:catalystsupport@sagepub.com">
          catalystsupport@sagepub.com
        </a>
      </p>
    </div>
  );
};

export default DisabledTenant;
